import { useState } from "react";
import { Col, Pagination, Row, Table, Button } from "antd";

import { phonebookTableColumn } from "./Columns";
import { AddPhonebookModal } from "../../../pages/Campaign/component/AddPhonebookModal";
import { getPhonebooks } from "../../../services/adminController";
import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

export function PhonebookTable({
  data,
  pageSize,
  totalRecords,
  isPending,
  status_type,
}: any) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentPageNumber, setCurrentPageNumber] = useState<number>(1);
  const queryClient = useQueryClient();

  const {
    data: phonebooks,
    isPending: isPhonebookPending,
    isRefetching: isPhonebookRefetching,
  } = useQuery({
    queryKey: ["agentAdminActiveCases", currentPageNumber],
    queryFn: () => getPhonebooks(currentPageNumber),
    placeholderData: keepPreviousData,
    refetchOnMount: true,
  });

  const refetchPhonebooks = () => {
    setTimeout(() => {
      queryClient.invalidateQueries({
        queryKey: ["agentAdminActiveCases"],
        exact: false,
      });
    }, 1000);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleOnChange = (page: number, pageSize: number | undefined) => {
    setCurrentPageNumber(page);
  };

  return (
    <Col>
      <Row className="flex justify-between"></Row>
      <div className="flex justify-between items-center">
        <Button
          type="default"
          htmlType="button"
          className="ml-auto mb-5"
          onClick={handleOpenModal}
        >
          Create Phonebook
        </Button>
      </div>
      <Table
        loading={isPhonebookPending || isPhonebookRefetching}
        columns={phonebookTableColumn}
        dataSource={phonebooks?.data || []}
        size="middle"
        pagination={false}
        style={{ cursor: "pointer" }}
      />
      <Row className="flex justify-center pt-6 pb-6">
        <Pagination
          //   showSizeChanger
          pageSize={phonebooks?.pageSize}
          total={phonebooks?.totalResults}
          onChange={handleOnChange}
          current={phonebooks?.currentPage}
        />
      </Row>
      <AddPhonebookModal
        status={isModalOpen}
        onCancel={handleCloseModal}
        refetchPhonebooks={refetchPhonebooks}
      />
    </Col>
  );
}
